module.exports = __webpack_public_path__ + "static/media/Results-4.8c64ea7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proof/Results-4.jpg
// module id = 367
// module chunks = 0